import React from 'react';
import { useHistory } from '../../../providers/HistoryProvider';
import { TemplateType } from '@neum/frontend-shared/constants/templateData';
import { DocumentActionPromptBanner } from '../common/DocumentActionPromptBanner';

interface GenerateNotesBannerProps {
    title?: string
    description?: string
}

export const GenerateNotesBanner: React.FC<GenerateNotesBannerProps> = ({
    title = "Generate Notes",
    description = "Generate your notes for this visit.",
}: GenerateNotesBannerProps) => {
    const {
        activeSession,
        template,
        setTemplate,
        processNotes,
        activeNotes,
        multiDocEligible,
        activeRecordingsAndTranscripts,
        createNotesWithSelected,
    } = useHistory()

    async function handleGenerateClick() {
        if (multiDocEligible) {
            const allRecordings = activeRecordingsAndTranscripts?.map(pair => pair.recording_id) ?? []
            if (allRecordings.length > 0) {
                await createNotesWithSelected(allRecordings, template)
            }
        } else {
            await processNotes(activeNotes ? true : false)            
        }
    }

    return <DocumentActionPromptBanner 
        title={title}
        description={description}
        templateType={TemplateType.MEDICAL}
        template={template}
        setTemplate={setTemplate}
        templateIdForce={activeSession?.template_id}
        externalTemplateId={activeSession?.external_template_id}
        buttonText="Generate"
        onButtonClick={handleGenerateClick}
    />
};